import axios from 'axios'
import baseUrl from './baseUrl'

const instance = axios.create({ baseURL: baseUrl() })
instance.defaults.withCredentials = true

/* eslint-disable-next-line import/no-mutable-exports */
let csrfToken = null

instance.interceptors.request.use(config => ({
  ...config,
  headers: {
    ...config.headers,
    'X-CSRF-Token': csrfToken,
  },
}))

instance.interceptors.response.use(response => {
  if (response.headers['csrf-token']) {
    csrfToken = response.headers['csrf-token']
  }

  return response
})

export default instance
export { csrfToken }
